import { useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { useTokensPrice } from '~/hooks/useTokenPrice'
import { useStEthBalance } from './useStEthBalance'
import { useWstEthBalance } from './useWstEthBalance'
import { stETH, wstETH } from '~/constants/tokens'

export const useWithdrawalTokens = () => {
  const stEthBalance = useStEthBalance()
  const formattedStEthBalance = stEthBalance?.toDecimalsFixed()
  const wstEthBalance = useWstEthBalance()
  const formattedWstEthBalance = wstEthBalance?.toDecimalsFixed()

  const tokens = [stETH.address, wstETH.address]
  const prices = useTokensPrice(tokens)

  const formattedTokens = useMemo(() => {
    const stEthPriceUSD = new BigNumber(prices[stETH.address])
      .multipliedBy(formattedStEthBalance ?? '0')
      .toFixed(2)
    const wstEthPriceUSD = new BigNumber(prices[wstETH.address])
      .multipliedBy(formattedWstEthBalance ?? '0')
      .toFixed(2)
    const formattedStETH = {
      ...stETH,
      balance: formattedStEthBalance,
      priceUSD: stEthPriceUSD,
    }
    const formattedWstETH = {
      ...wstETH,
      balance: formattedWstEthBalance,
      priceUSD: wstEthPriceUSD,
    }
    return [formattedStETH, formattedWstETH]
  }, [prices, formattedStEthBalance, formattedWstEthBalance])

  return formattedTokens
}
